import { __extends } from "tslib";
import { Box } from '../classes';
var MtcnnBox = /** @class */ (function (_super) {
    __extends(MtcnnBox, _super);
    function MtcnnBox(left, top, right, bottom) {
        return _super.call(this, { left: left, top: top, right: right, bottom: bottom }, true) || this;
    }
    return MtcnnBox;
}(Box));
export { MtcnnBox };
//# sourceMappingURL=MtcnnBox.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/mtcnn/MtcnnBox.js
// module id = 621
// module chunks = 0